import React from "react";
type CourtLinesProps = {
  className?: string;
};
export function CourtLines({
  className
}: CourtLinesProps) {
  return <svg viewBox="0 0 400 400" fill="none" className={className} aria-hidden="true" data-id="element-23" data-mp="19487zqn14tbh">
      <circle cx="200" cy="200" r="198" stroke="currentColor" strokeWidth="1" data-id="element-24" data-mp="1432a7eeiifv3" />
      <circle cx="200" cy="200" r="128" stroke="currentColor" strokeWidth="1" data-id="element-25" data-mp="102rvndcnmh4m" />
      <circle cx="200" cy="200" r="5" fill="currentColor" data-id="element-26" data-mp="v35i12swyyva" />
      <line x1="0" y1="200" x2="400" y2="200" stroke="currentColor" strokeWidth="1" data-id="element-27" data-mp="v4qe4wuvmpv9" />
    </svg>;
}